module.exports = __webpack_public_path__ + "static/media/minimize.846dfdb3.svg";